import querystring from "querystring";
import { emitAddToCartLegacy } from "@catchoftheday/analytics";
import { dispatchEventBus } from "@catchoftheday/state";
import axios from "axios";
import {
  ToastContentProps,
  createToast,
  ItemProps,
  updateToast,
} from "@catchoftheday/header-app";

export const SERVER_ERROR = "Unable to add to cart. Please try again later.";

type AddToCartPayload = any;

type AddToCartInput = {
  sourceId?: string | number;
  sourceType?: number;
  sourcePosition?: number;
  sourcePlatform?: number | null;
  eventId: number;
  offerId: number;
  sellerId: number;
  id: number;
  trackEventToken?: string;
  imageUrl: string;
  title: string;
};

export function addToCart({
  eventId,
  id,
  offerId,
  sellerId,
  sourceId,
  sourcePosition,
  sourceType,
  sourcePlatform,
  trackEventToken,
  imageUrl,
  title,
}: AddToCartInput): Promise<AddToCartPayload> {
  const srtrev = trackEventToken ? `${trackEventToken}.cart` : undefined;

  const toastItem: ItemProps = {
    message: "Adding...",
    status: "info",
    imageUrl,
    title,
  };

  const toastContent: ToastContentProps = {
    items: [toastItem],
    showCheckoutOnSuccess: true,
  };

  const toastId = createToast({ toastContent });

  return axios
    .post(
      "/cart/item.json",
      querystring.stringify({
        source_id: sourceId,
        source_type: sourceType,
        source_position: sourcePosition,
        source_platform: sourcePlatform,
        event_id: eventId,
        offer_id: offerId,
        seller_id: sellerId,
        product_id: id,
        srtrev,
      }),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    )
    .then((result) => {
      dispatchEventBus({
        type: "@cart-app/ADD_TO_CART",
      });

      emitAddToCartLegacy({
        eventId,
        offerId,
        productId: id,
        sellerId,
        snowplowContexts: result.data?.contexts,
        sourceType,
        sourcePosition,
        sourceId,
        srtrev,
      });
      updateToast({
        toastId,
        toastContent: {
          ...toastContent,
          items: [{ ...toastItem, message: "Added!", status: "success" }],
        },
      });

      return result?.data;
    })
    .catch((e) => {
      updateToast({
        toastId,
        toastContent: {
          ...toastContent,
          items: [
            {
              ...toastItem,
              message:
                e.response?.data?.errors?.[0] || SERVER_ERROR || e.message,
              status: "error",
            },
          ],
        },
      });
    });
}
